import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=0c011230&scoped=true&"
import script from "./trade.vue?vue&type=script&lang=js&"
export * from "./trade.vue?vue&type=script&lang=js&"
import style0 from "./trade.vue?vue&type=style&index=0&id=0c011230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c011230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/daniel/work/jiangxi/fed-sd-visual-web-static/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c011230')) {
      api.createRecord('0c011230', component.options)
    } else {
      api.reload('0c011230', component.options)
    }
    module.hot.accept("./trade.vue?vue&type=template&id=0c011230&scoped=true&", function () {
      api.rerender('0c011230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/bussiness/report-amount/trade.vue"
export default component.exports